<script lang="ts">
    import {Component, Prop, toNative, Vue} from 'vue-facing-decorator'
    import Breadcrumbs from '~src/components/Breadcrumbs.vue'

    @Component({mixins: [Breadcrumbs]})
    export class VisaBreadcrumbs extends Vue {
        @Prop({required: true}) searchRequest

        get items() {
            const name = useRoute().name
            const items = [this.homeItem]
            switch (name) {
                case 'visaSearch':
                    items.push({
                        title: `${visaRuntimeStore.location.name}`,
                        to: visaRuntimeStore.searchPageLink(this.searchRequest),
                        disabled: true,
                        exact: true,
                    })
                    break
                case 'visa':
                    break
                case 'visaBooking':
                    items.push({
                        title: `${visaRuntimeStore.location.name}`,
                        to: visaRuntimeStore.searchPageLink(this.searchRequest),
                        exact: true,
                    })
                    items.push({
                        title: this.$t('reservation'),
                        disabled: true,
                    })
                    break
                case 'visaConfirmation':
                    break
            }
            return items
        }
    }

    export default {...toNative(VisaBreadcrumbs), ssrRender: Breadcrumbs.ssrRender}
</script>
